//paddle
(function(){
    try{
        function money_e(e){ 
          var myCurrencyArray = new Array ("ARS","AUD","BRL","GBP","CAD","CNY","CZK","DKK","EUR","HKD","HUF","INR","JPY","MXN","TWD","NZD","PLN","RUB","SGD","ZAR","KRW","SEK","CHF","USD");
          var myCurrencyArray_Symbol = new Array ("$","A$","R$","£","CA$","¥","Kč","kr","€","HK$","Ft","₹","¥","$","NT$","NZ$","zł","RUB","SGD","R","₩","kr","₣","$"); 
          for (var i=0; i<myCurrencyArray.length;i++) 
          { 
            if(myCurrencyArray [i]==e)
                return myCurrencyArray_Symbol[i];
          } 
          return e;
        }
        function formatnumber(num) {
            var result = parseFloat(num);
            if (isNaN(result)) {
                
            return false;
            }
            result = Math.round(num * 100) / 100;
            var s_x = result.toString();
            var pos_decimal = s_x.indexOf('.');
            if (pos_decimal < 0) {
            pos_decimal = s_x.length;
            s_x += '.';
            }
            while (s_x.length <= pos_decimal + 2) {
            s_x += '0';
            }
            return s_x;
        }
        var coupons={
            "APEAKDHG":.8,
            "APKFNWT":.7,
            "APKTPRD":.6,
            "APKFNCD":.6,
            "APKOPLE":.5,
            "APKEGNK":.5,
            "APKSHIJP":.5,
            "APEAK-ABC":.5,
            "APKBDP":.45,
            "APKBDOT":.4,
            "APKISWE": .6,
            "APK-UTWS":.6,
            "APKSUR":.5
        }
        Paddle.Setup({
            vendor: 106347,
            eventCallback:function(data){
                console.log(data);
                console.log(data.event);
                if(data.event=="Checkout.Loaded"){
                        dataLayer.push({'event': 'LoadedCallback'});

                }else if(data.event=="Checkout.Login"){
                        dataLayer.push({'event': 'LoginCallback'});

                }else if(data.event=="Checkout.Location.Submit"){
                        dataLayer.push({'event': 'SubmitCallback'});

                }else if(data.event=="Checkout.PaymentMethodSelected"){
                        dataLayer.push({'event': 'PaymentMethodSelectedCallback'});
                    
                }else if(data.event=="Checkout.PaymentComplete"){
                        dataLayer.push({'event': 'PaymentCompleteCallback'});
                }else{

                }
            }}
        );
        function openCheckout() {
            if($(this).attr('coupon')=='APK100'){
                alert('Please select one or more products to continue checking out.');
                return false;
            }
            Paddle.Checkout.open({
                product: $(this).attr('product-id'),
                coupon: $(this).attr('coupon'),
                closeCallback: function(data) {
                  dataLayer.push({'event': 'checkoutClose'});
                }
            });
        }
        $('a.paddle').click(openCheckout);
        $('a.paddle.unbind').unbind('click');
        for(var i=0;i<$('a.paddle').length;i++){
            (function(i){
            $.ajax({
                url: 'https://checkout.paddle.com/api/2.0/prices',
                dataType: 'jsonp',
                data: {
                product_ids: $('a.paddle').eq(i).attr('product-id'),
                coupons:$('a.paddle').eq(i).attr('coupon')
                },
                success: function (reg) {
                    try{
                        if(coupons[$('a.paddle').eq(i).attr('coupon')]){
                            
                            $('.paddle-price').eq(i).html(money_e(reg.response.products[0].currency)+formatnumber(reg.response.products[0].list_price.net*coupons[$('a.paddle').eq(i).attr('coupon')]));
                            $('.paddle-price-del').eq(i).html(money_e(reg.response.products[0].currency)+formatnumber(reg.response.products[0].list_price.net));
                        }else{
                            $('.paddle-price').eq(i).html(money_e(reg.response.products[0].currency)+formatnumber(reg.response.products[0].list_price.net));
                            $('.paddle-price-del').eq(i).html(money_e(reg.response.products[0].currency)+formatnumber(reg.response.products[0].list_price.net));
                        }
                    }catch(e){
                        console.log(e);
                    }
                }
            });
            })(i)
        }
    }catch(e){
        console.log(e);
    }
})();